import {memoize} from 'lodash-es'
import * as pathToRegexp from 'path-to-regexp'


export type Parameters = Record<string, string | string[]>

const compile = memoize(pathToRegexp.compile)
const generatePath = (path: string, parameters: Parameters = {}) => compile(path)(parameters)

export default generatePath
